import { useCallback, useState } from 'react'
import useSWR from 'swr'
import { CommunitySearchSuggestion } from '../types/community-search-suggestion'

const data: CommunitySearchSuggestion[] = [
  {
    id: 1,
    value: 'Job',
  },
  {
    id: 2,
    value: 'Join',
  },
  {
    id: 3,
    value: 'Journey',
  },
]

const fetcher = () =>
  new Promise<CommunitySearchSuggestion[]>(resolve => {
    setTimeout(() => {
      resolve(data)
    }, 3000)
  })

export const useCommunitySearchSuggestions = ({ query }: { query?: string } = {}) => {
  const [shouldFetch, setShouldFetch] = useState(false)

  const { data, isLoading } = useSWR(() => {
    if (!shouldFetch) return null
    const url = `/api/community/search/suggestions?query=${query}`
    return url
  }, fetcher)

  const init = useCallback(() => setShouldFetch(true), [])

  return { suggestions: data, isLoading, init }
}
